<template>
  <div>
    <Button type="primary" size="small" @click="fileSelect">上传</Button>
    <input type="file" ref="file" style="display:none" @change="fileUpload">
  </div>
</template>

<script>
export default {
  name: 'uploadBtn',
  props: ['mark'],
  methods: {
    fileSelect() {
      this.$refs.file.click()
      this.$emit('beforeUpload', this.mark)
    },
    fileUpload() {
      const file = this.$refs.file.files[0]
      this.$emit('fileSelected', file)
    }
  }
}
</script>
